import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "scroll !important",
    height: "100vh",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  iframe: {
    width: "100%",
    height: "100%",
    borderWidth: 0,
    paddingTop: 70,
    background: theme.colors.Background1,
    color: theme.colors.TextDefault,
  },
}));
